import { render, staticRenderFns } from "./CourseManagement.vue?vue&type=template&id=3387d528"
import script from "./CourseManagement.vue?vue&type=script&lang=ts"
export * from "./CourseManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports